import FetchEmployee from 'utils/fetch/FetchEmployee'
import _ from 'lodash'
import GraphqlBuilder, { graphqlOptions } from 'utils/request/graphql/builder'
import MutationEmployee from 'graphql/mutations/MutationEmployee'
import CacheStorage from 'utils/cache/CacheStorage'
import store from 'services/redux/store'
import { dataConstants } from 'services/redux/data/constants'
import { FormStatus } from 'utils/constants/form-constants';
import MutationEmployeeWorkdays from 'graphql/mutations/MutationEmployeeWorkdays'

export default class EmployeeValues {
	
	static values = {};
	
	static reloadEmployee = () => {
		const _employee = store.getState().data[ dataConstants.EMPLOYEE ];
		
		FetchEmployee.fetch( _employee.guid, { dispatchDataToStore: true } );
	}
	
	static getEmployeeField = ( _employee, field, defaultValue = '' ) => {
		let value = _.get( this.values, field, null )
		if( value === null ) {
			value = _.get( _employee, field, null )
			
			if( value === null ) {
				value = defaultValue
			}
		}
		
		return value;
	}
	
	static resetEmployee = () => {
		this.values = {}
	}
	
	static onChangeEmployee = ( values ) => {
		if( _.size( values ) > 0 ) {
			this.values = {
				...this.values,
				...values
			};
		}
	}
	
	static submitEmployee = ( callback = () => {
	} ) => {
		if( _.size( this.values ) === 0 ) {
			// fake saving (just for the shit of it)
			callback( FormStatus.LOADING );
			setTimeout( () => {
				return callback(FormStatus.SUCCESS);
			}, 1000 );
			return;
		}
		
		const _employee = store.getState().data[ dataConstants.EMPLOYEE ];
		
		let restartApp = false;
		if( _.get( this.values, 'language_guid', null ) !== null ) {
			if( _.get( _employee, [ 'language', 'guid' ] ) !== _.get( this.values, 'language_guid', null ) ){
				restartApp = true;
			}
		}
		
		const builder = new GraphqlBuilder({ [ graphqlOptions.processVariables ]: false } )
		builder.setOnStart( () => {
			return callback(FormStatus.LOADING);
		} )
		builder.setOnError( result => {
			callback( FormStatus.ERROR );
		})
		
		builder.setOnSuccess( result => {
			if( restartApp ) {
				CacheStorage.clearCache( { restart: true } );
			} else {
				EmployeeValues.reloadEmployee();
			}
			
			callback( FormStatus.SUCCESS );
		})
		
		// Check if workdays are set
		if( _.has( this.values, 'workdays' ) ) {
			_.forEach( this.values.workdays, workday => {
				builder.addQuery( `mutation_workday_${ workday.workday_day}`, MutationEmployeeWorkdays, workday )
			})
		}
		
		const _values = _.omit( this.values, ['workdays'] )
		
		// Are there values left?
		if( _.size( _values ) > 0 ) {
			builder.addQuery('mutation', MutationEmployee, _values )
		}
		
		builder.execute()
	}
}
